import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ 
  activeTab, 
  selectedSchoolType = "secondary",
  leftContent,
  isLargeScreen,
  setSidebarOpen,
  sidebarOpen,
  onSupportClick
}) => {
  return (
    <header className="bg-blue-600 text-white p-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="flex items-start gap-4 w-full md:w-auto">
          {/* Filter button area */}
          {leftContent && (
            <div className="mt-1">
              {leftContent}
            </div>
          )}
          
          {/* Show filter button directly if props are passed and not large screen */}
          {!leftContent && !isLargeScreen && setSidebarOpen !== undefined && (
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="border rounded px-3 py-2 text-sm bg-white hover:bg-gray-100 flex items-center mt-1"
              aria-label="Open filter options"
            >
              <span className="text-blue-600">Filter</span>
            </button>
          )}
          
          <div className="flex-1">
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold">Melbourne's Best School Zones by Property Price</h1>
            <p className="text-xs sm:text-sm text-blue-100 mt-1">
              {activeTab === 'map' && "Find top-performing schools by house prices in Melbourne, Victoria."}
              {activeTab === 'rankings' && "School Rankings & Property Prices"}
              {activeTab === 'faq' && "FAQ and Help Guide"}
            </p>
          </div>
        </div>
        
        <div className="flex gap-1 sm:gap-2 mt-0 md:mt-0 self-start items-center">
          <Link 
            to={`/victoria/${selectedSchoolType}`} 
            className={`${activeTab === 'map' ? 'bg-blue-700 text-white hover:bg-blue-800' : 'bg-white text-blue-600 hover:bg-gray-100'} px-2 sm:px-3 md:px-4 py-2 rounded text-sm sm:text-base font-medium`}
          >
            School Zones and Price
          </Link>
          <Link 
            to={`/schools/${selectedSchoolType}`} 
            className={`${activeTab === 'rankings' ? 'bg-blue-700 text-white hover:bg-blue-800' : 'bg-white text-blue-600 hover:bg-gray-100'} px-2 sm:px-3 md:px-4 py-2 rounded text-sm sm:text-base font-medium`}
          >
            School Rankings
          </Link>
          <Link 
            to="/faq" 
            className={`${activeTab === 'faq' ? 'bg-blue-700 text-white hover:bg-blue-800' : 'bg-white text-blue-600 hover:bg-gray-100'} px-2 sm:px-3 md:px-4 py-2 rounded text-sm sm:text-base font-medium`}
          >
            FAQ
          </Link>
          <button
            onClick={onSupportClick}
            className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-3 md:px-4 py-2 rounded text-sm sm:text-base flex items-center"
            type="button"
          >
            ☕ Support Us
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;